import {
  Root,
  Content,
  Title,
  Description,
  UpgradeButton,
} from './upgrade-banner.parts';

export const UpgradeBanner = {
  Root: Root,
  Content: Content,
  Title: Title,
  Description: Description,
  UpgradeButton: UpgradeButton,
};
